import React from 'react';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import FullPageState from './FullPageState';

function Unauthorized() {
  const navigate = useNavigate();

  return (
    <FullPageState
      icon={<LockOutlinedIcon fontSize="inherit" />}
      eyebrow="Access control"
      statusLabel="403 · Restricted area"
      title="Access denied"
      description="You do not have permission to view this page."
      supportingText="Your account is still signed in. Return to the dashboard to continue with the areas available to your role."
      actions={(
        <Button
          className="full-page-state__primary-action"
          variant="contained"
          disableElevation
          onClick={() => navigate('/dashboard')}
        >
          Go to Dashboard
        </Button>
      )}
    />
  );
}

export default Unauthorized;
